import { render } from "./Collapse.vue?vue&type=template&id=02debf89"
import script from "./Collapse.vue?vue&type=script&lang=js"
export * from "./Collapse.vue?vue&type=script&lang=js"

import exportComponent from "D:\\ASMPP\\ASMPP_VUE\\asmpp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__